/*
  Hartekiste gift-box option.
  Toggling the cart checkbox adds/removes the wooden-box add-on product.
  One box per order. Uses event delegation so it survives cart re-renders.

  - In the cart drawer: refreshes the drawer + cart bubble via the Section
    Rendering API (no full page reload, drawer stays open).
  - On the cart page: reloads so the totals + hidden line item update cleanly.
*/
(function () {
  if (window.__bbqGiftBoxInit) return;
  window.__bbqGiftBoxInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshDrawer(sections) {
    if (sections['cart-drawer']) {
      var inner = sectionInner(sections['cart-drawer'], '#CartDrawer');
      var drawerEl = document.querySelector('#CartDrawer');
      if (inner != null && drawerEl) drawerEl.innerHTML = inner;
    }
    if (sections['cart-icon-bubble']) {
      var bubbleInner = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && bubbleInner != null) bubble.innerHTML = bubbleInner;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) cd.classList.remove('is-empty');
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-gift-box-toggle]')) return;

    var variantId = el.getAttribute('data-variant-id');
    var lineKey = el.getAttribute('data-line-key');
    var inDrawer = !!el.closest('#CartDrawer');
    el.disabled = true;

    var url = el.checked ? 'cart/add.js' : 'cart/change.js';
    var body = el.checked
      ? { id: Number(variantId), quantity: 1 }
      : { id: lineKey || variantId, quantity: 0 };

    if (inDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (inDrawer && data && data.sections) {
          refreshDrawer(data.sections);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        el.disabled = false;
        el.checked = !el.checked;
      });
  });
})();
